// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Home from '../../pages/Home';

type Props = {
  version: string;
};

@connect(({ version: { string } }) => ({
  version: string
}))
export default class HomeContainer extends Component<void, Props, void> {
  render() {
    const { props: { version } } = this;

    return (
      <div>
        <Home version={version} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/HomeContainer/index.jsx